// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"svg-shapes_closeIcon__dGxcP","backArrow":"svg-shapes_backArrow__gxFbY"};